// extracted by mini-css-extract-plugin
module.exports = {"tab-item-header":"TabItemHeader_tab-item-header__1zCR4","tab-item-header--selected":"TabItemHeader_tab-item-header--selected__U9ubW"};